import { createStore } from 'satcheljs';

export const getStore = createStore('asyncRecipientWell', {
    isLoaded: false,
});
